{
  "RESET_PASSWORD": {
    "TITLE": "Đặt lại mật khẩu",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Thư điện tử",
      "PLACEHOLDER": "Vui lòng nhập email.",
      "ERROR": "Vui lòng nhập email hợp lệ."
    },
    "API": {
      "SUCCESS_MESSAGE": "Liên kết đặt lại mật khẩu đã được gửi đến email của bạn.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "SUBMIT": "Gửi"
  }
}
